import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

export default function WelcomePage({ onEnter }) {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleEnter = () => {
    setIsAnimating(true);
    setTimeout(() => {
      onEnter();
    }, 300);
  };

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#0021A5] to-[#FA4616] ${
        isAnimating ? "opacity-0 scale-95" : "opacity-100 scale-100"
      }`}
      style={{ transition: "opacity 0.3s, transform 0.3s" }}
      data-testid="welcome-page"
    >
      {/* Logo */}
      <div className="mb-8 animate-fade-in">
        <img
          src="https://customer-assets.emergentagent.com/job_8e534113-c2c4-4f3f-8864-185da76b04eb/artifacts/d11zdlcb_XK%20Inclusive%20GameDay%20Logo.png"
          alt="XTERMIGATOR Kids Inclusive Game Day Logo"
          className="w-80 h-80 md:w-96 md:h-96 object-contain drop-shadow-2xl"
          data-testid="welcome-logo"
        />
      </div>

      {/* Welcome Text */}
      <div className="text-center mb-8">
        <h1
          className="text-2xl md:text-3xl font-bold text-white mb-4 drop-shadow-lg"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Welcome to
        </h1>
        <h2
          className="text-3xl md:text-4xl font-bold text-white mb-6 drop-shadow-lg"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          XTERMIGATOR Kids
          <br />
          Inclusive Game Day
        </h2>
        
        {/* Attribution */}
        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 mb-6">
          <p className="text-white/90 text-sm md:text-base leading-relaxed">
            A Graduate Project for the
            <br />
            <span className="font-semibold">College of Education</span>
          </p>
          <p className="text-white text-sm md:text-base mt-2">
            by <span className="font-bold">Dr. Eric S. Fishon</span>
          </p>
          <p className="text-white/80 text-xs mt-1">
            Founder/Creator of XTERMIGATOR Kids
          </p>
        </div>
      </div>

      {/* Enter Button */}
      <Button
        onClick={handleEnter}
        className="h-14 px-8 text-lg font-semibold bg-white text-[#0021A5] hover:bg-white/90 rounded-full shadow-lg hover:shadow-xl active:scale-95"
        style={{ fontFamily: "Lexend, sans-serif", transition: "transform 0.2s, box-shadow 0.2s" }}
        data-testid="enter-app-button"
      >
        Enter App
        <ChevronRight className="ml-2" size={24} />
      </Button>

      {/* Tagline */}
      <p className="mt-8 text-white/80 text-center text-sm max-w-xs">
        Making game days accessible and enjoyable for everyone
      </p>

      {/* University Badge */}
      <div className="mt-6 flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
        <span
          className="text-white font-bold text-lg"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          UF
        </span>
        <span className="text-white/80 text-sm">
          University of Florida
        </span>
      </div>
    </div>
  );
}
